module.exports = "/src/assets/images/project.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project.jpg
// module id = 36
// module chunks = 0